import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { useMsal } from "@azure/msal-react";
import logo from "../Header/La_Loutiquebem.svg";
import Divider from "@mui/material/Divider";
export default function Auth() {
	const { instance } = useMsal();
	function handleLogin() {
		instance.loginRedirect({ scopes: ["User.Read"] }).catch((e) => {
			console.error(e);
		});
	}

	return (
		<Box
			width={"100vw"}
			height={"100vh"}
			position="absolute"
			display="flex"
			justifyContent="center"
			//alignContent="center"
			overflow="hidden"
		>
			<Box
				component={"img"}
				position="absolute"
				sx={(theme) => ({
					opacity: 0.75,
					width: "110vw",
					[theme.breakpoints.up("lg")]: {
						width: "80vw",
					},
				})}
				src={logo}
				alt="Logo La Loutiquebem"
				overflow="hidden"
			/>
			<Paper
				elevation={12}
				sx={(theme) => ({
					zIndex: 2,
					height: "fit-content",
					p: 1,
					display: "flex",
					flexDirection: "column",
					[theme.breakpoints.down("sm")]: {
						width: "90vw",
						m: "auto",
					},
					[theme.breakpoints.up("sm")]: {
						m: "auto",
					},
				})}
			>
				<Typography
					variant="h3"
					color="primary"
					fontFamily="Fjalla One"
				>
					Bienvenue !
				</Typography>
				<Divider
					sx={{
						borderColor: "secondary.main",
						borderWidth: 1.5,
						width: "10%",
						ml: 2,
						mb: 2,
					}}
				/>
				<Typography>
					Pour accéder aux ventes de La Loutiquebem, merci de vous
					connecter 😄
				</Typography>
				<Button
					variant="contained"
					color="info"
					size="small"
					sx={{ mt: 1, alignSelf: "center", width: "60%" }}
					onClick={() => handleLogin()}
				>
					Se Connecter
				</Button>
			</Paper>
		</Box>
	);
}
